<div class="page tracking history">
  <div class="lefttrack">
    <div class="lefttrack-block">
      <div class="topleft" id="topleft">
        <app-devices-list [trackingMode]="true"></app-devices-list>
      </div>
    </div>
  </div>

  <div class="vert_collapser" id="vert_collapser" onclick="collapseTrack()">
    <span><i></i></span>
  </div>

  <div class="righttrack">
    <div class="bottomright" id="bottomright">
      <div class="navblock">
        <div></div>
        <div class="inputgroup">
          <input class="dtpickerupleft" type="text" value="">
        </div>
        <button id="setintervalbtn" class="btn_blue">{{'Apply'|translate }}</button>
      </div>
      <div class="rightreport">
        <div class="tablewrap resizetable">
          <div class="table" id="maintable_print">
            <div class="reportinfo">
              <div id="maintable" class="resizetable">
                <table fixedcols="[7]" id="checkups">
                  <tr>
                    <th class='object_column'>{{'Object'|translate }}</th>
                    <th class='datetime_column'>{{'Date'|translate }}</th>
                    <th class='object_column'>{{'Operator'|translate }}</th>
                    <th>{{'Description'|translate }}</th>
                    <th class='mileage_column'>{{'Odometer'|translate }}</th>
                    <th class='avg_column'>{{'Engine time'|translate }}</th>
                    <th class='avg_column'>{{'Fueling'|translate }}</th>
                    <th class='object_column'>{{'Address'|translate }}</th>
                    <th></th>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <app-pagination [viewmode]="'print excel reports'" [printElementID]="'maintable_print'"></app-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
